// extracted by mini-css-extract-plugin
export default {"content":"ApplicantReview_content__l9ZR2","statusWrap":"ApplicantReview_statusWrap__aCpWe","btnWrap":"ApplicantReview_btnWrap__a0HID"};